var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-tags",style:([_vm.hasBorder ? _vm.getBorder : 'null'])},_vm._l((_vm.propValue),function(value,i){return _c('div',{key:i,staticClass:"tags"},[_c('span',{staticClass:"tag"},[_vm._v(_vm._s(value))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4193190a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/CardTags.vue
// module id = null
// module chunks = 